<template>
  <div>{{ tipMessage }}</div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
const props = defineProps({
  detail: { type: Object, default: () => ({}) }
})
const tipMessage = computed(() => props.detail.tipMessage)
</script>

<style lang="scss" scoped></style>
